import React from 'react';
import MarketingLayout from './components/MarketingLayout.js';
import MarketingFooterCtas from './components/MarketingFooterCtas.js';
import './TechArticlesPage.css';

export default function TechArticlesPage() {
  return (
    <MarketingLayout>
      <div className="marketing-page-content tech-articles-page">
        <div className="tech-articles-container">
          <h1>AI-Driven Socratic Method for Entrepreneurship</h1>
          <p>
            The ZOLAID AI assistant employs a sophisticated Socratic method to guide entrepreneurs through the process of refining their business ideas. This approach moves beyond simple Q&A, fostering critical thinking and deeper understanding by posing insightful questions rather than just providing answers.
          </p>

          <h2>Key Principles of the Socratic Method in ZOLAID:</h2>

          <h3>1. Initial Hypothesis Formulation:</h3>
          <p>
            Users are encouraged to articulate their initial business idea, however nascent. ZOLAID's role is to gently challenge assumptions and encourage clarity.
          </p>
          <div className="tech-article-prompts">
            <strong>Example prompts</strong>
            <ul>
              <li>"What is the core problem your business aims to solve?"</li>
              <li>"Who are your primary target customers, and what do you know about their current struggles?"</li>
              <li>"How is your proposed solution different from what's already available?"</li>
            </ul>
          </div>

          <h3>2. Deeper Exploration and Uncovering Assumptions:</h3>
          <p>
            Once an initial idea is presented, ZOLAID delves deeper, prompting the entrepreneur to critically examine their underlying assumptions.
          </p>
          <div className="tech-article-prompts">
            <strong>Example prompts</strong>
            <ul>
              <li>"You mentioned your target market is 'young professionals.' What specific challenges do they face that your product addresses?"</li>
              <li>"What evidence do you have that customers are currently dissatisfied with existing solutions?"</li>
              <li>"If your product succeeded beyond your wildest dreams, what would that look like, and what steps would lead there?"</li>
            </ul>
          </div>

          <h3>3. Validation and Refinement:</h3>
          <p>
            The AI helps the entrepreneur think through how to validate their ideas and refine them based on potential feedback or market research.
          </p>
          <div className="tech-article-prompts">
            <strong>Example prompts</strong>
            <ul>
              <li>"How would you test if your target customers actually have this problem?"</li>
              <li>"What's the smallest version of your product you could build to get initial user feedback?"</li>
              <li>"Considering your competitors, what unique value proposition truly sets you apart?"</li>
            </ul>
          </div>

          <h3>4. Identifying Potential Obstacles and Solutions:</h3>
          <p>
            ZOLAID encourages foresight, prompting the entrepreneur to consider potential roadblocks and brainstorm solutions proactively.
          </p>
          <div className="tech-article-prompts">
            <strong>Example prompts</strong>
            <ul>
              <li>"What are the biggest risks you foresee in bringing this idea to market?"</li>
              <li>"If your product fails, what would be the most likely reason? How can you mitigate that now?"</li>
              <li>"What resources (financial, human, technical) do you anticipate needing, and how will you acquire them?"</li>
            </ul>
          </div>

          <h2>Benefits of this Approach:</h2>
          <ul>
            <li><strong>Critical Thinking:</strong> Encourages entrepreneurs to think deeply rather than seeking quick answers.</li>
            <li><strong>Ownership:</strong> Users arrive at solutions themselves, fostering greater ownership and commitment.</li>
            <li><strong>Robust Ideas:</strong> Ideas are more thoroughly vetted and resilient to challenges.</li>
            <li><strong>Unbiased Guidance:</strong> The AI provides objective, question-based guidance free from personal biases.</li>
          </ul>

          <p>
            Through this guided inquiry, ZOLAID aims to empower entrepreneurs to not just develop ideas, but to truly understand and strengthen their business foundations.
          </p>
        </div>

        <MarketingFooterCtas />
      </div>
    </MarketingLayout>
  );
}
